import { useCallback } from 'react'
import { IssuesModule } from '@/core/modules/issues'
import { UsersModule } from '@/core/modules/users'

export const useAllIssues = () => {
    const { data: issues } = IssuesModule.useStore()
    const fdIssues = UsersModule.getFdIssuesAsIssues()
    const becIssues = UsersModule.getBecIssues()
    const allIssues = [...fdIssues, ...becIssues, ...issues]

    const getIssueById = useCallback(
        (id: string): TIssue | undefined =>
            allIssues.find((issue: TIssue) => issue.id === id),
        [allIssues]
    )

    return {
        data: allIssues,
        getIssueById,
    }
}
